import { FirestoreError } from './firestoreTypes'

export class FirestoreErrorHandler {
  handleGetDocumentError(collectionName: string, documentId: string, error: unknown): never {
    throw new FirestoreError(
      `Error al obtener documento ${documentId} de ${collectionName}`,
      'get-document-error',
      error
    )
  }

  handleGetDocumentsError(collectionName: string, error: unknown): never {
    console.error('[Firestore] Error al obtener documentos:', collectionName, error)
    throw new FirestoreError(
      `Error al obtener documentos de ${collectionName}`,
      'get-documents-error',
      error
    )
  }

  handleCreateDocumentError(collectionName: string, error: unknown): never {
    console.error('[Firestore] Error al crear documento:', collectionName, error)
    throw new FirestoreError(
      `Error al crear documento en ${collectionName}`,
      'create-document-error',
      error
    )
  }

  handleUpdateDocumentError(
    collectionName: string,
    documentId: string,
    error: unknown
  ): never {
    console.error('[Firestore] Error al actualizar:', error)
    throw new FirestoreError(
      `Error al actualizar documento ${documentId} en ${collectionName}`,
      'update-document-error',
      error
    )
  }

  handleSetDocumentError(collectionName: string, documentId: string, error: unknown): never {
    throw new FirestoreError(
      `Error al establecer documento ${documentId} en ${collectionName}`,
      'set-document-error',
      error
    )
  }

  handleDeleteDocumentError(
    collectionName: string,
    documentId: string,
    error: unknown
  ): never {
    throw new FirestoreError(
      `Error al eliminar documento ${documentId} de ${collectionName}`,
      'delete-document-error',
      error
    )
  }

  handleDocumentExistsError(
    _collectionName: string,
    documentId: string,
    error: unknown
  ): never {
    throw new FirestoreError(
      `Error al verificar existencia de documento ${documentId}`,
      'document-exists-error',
      error
    )
  }
}

export const firestoreErrorHandler = new FirestoreErrorHandler()
